export default __webpack_public_path__ + "static/media/pencil.e44159a7.svg";